import './index.scss'

import { Launchpad } from '@interfaces/launchpad.interface'

import iphoneFrame from 'url:@assets/images/iphone17_frame_portrait.png';

export default function LaunchpadViewPreview(props: {
  launchpad: Launchpad;
}) {
  const metadata = props.launchpad.metadata;

  return (
    <div className='launchpad-view-preview'>
      <div className='phone-shell'>
        <div className='phone-screen'>
          <div className='preview-surface'>
            <div className='header'>
              <div className='spacer' />
              <div className='title'>
                {metadata.attributes.logoURL ?
                  <img src={metadata.attributes.logoURL} alt={`${metadata.attributes.name} logo`} className='logo' /> :
                  <h3 className='title'>{metadata.attributes.name}</h3>
                }
              </div>
              <div className='spacer' />
            </div>

            <ul className='links'>
              {metadata.attributes.links.map((link, index) => {
                return (<li key={index} className='link'>
                  <a href={link.url} target='_blank' rel='noopener noreferrer'>{link.name}</a>
                </li>)
              })}
            </ul>
          </div>
        </div>

        <img src={iphoneFrame} alt='' aria-hidden='true' className='iphone-frame' />
      </div>
    </div>
  )
}
